import { isTextSelected, onDelegatedClick } from '../functions.js';

/**
 * Hace que si pones un attr href en un <tr> o <li> funcione como si fuera un <a>
 * Si dentro del <tr> se pincha en un <a> o <button> no se usa el href del <tr>
 * 
 * @since 2024-03-22 Poder especificar el attr "element-href-block" en cualquier subelemento para evitar que pinchando en él se abra el href
 */
export default class ElementHrefElement extends HTMLElement {

    connectedCallback() {

        onDelegatedClick(this, `
            :is(tr,li,div)[href] a, 
            :is(tr,li,div)[href] button, 
            :is(tr,li,div)[href] [element-href-block]
        `, e => {
            if (isTextSelected()) { return; }
            e.stopImmediatePropagation();
        });
    
        onDelegatedClick(this, ':is(tr,li,div)[href]', e => {
            if (isTextSelected()) { return; }
    
            let realTarget = e.target.closest(':is(tr,li,div)[href]');
    
            let href = realTarget.getAttribute('href');
    
            let ctrlKey = e.ctrlKey || e.metaKey;
    
            if (ctrlKey) {
                window.open(href, '_blank');
            } else if (realTarget.dataset.target) {
                window.open(href, realTarget.dataset.target);
            } else {
                location.href = href;
            }
        });
    
    }

}
window.customElements.define('element-href', ElementHrefElement);

